/* global axios */
import ApiClient from './ApiClient';

class ActivityAgendaAPI extends ApiClient {
  constructor() {
    super('activity_agenda', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }
}

export default new ActivityAgendaAPI();
